import React, { Component } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

class SelectJobPosition extends Component {
  constructor(props) {
    super(props);
    let defaultValue = '0';
    const { lan, defaultValue: dv } = this.props;
    if (dv === 'Administrative' || dv === 'Administrativo') defaultValue = lan.administrative;
    if (dv === 'Executive' || dv === 'Ejecutivo' || dv === 'Executivo') defaultValue = lan.executive;
    if (dv === 'Technical' || dv === 'Técnico') defaultValue = lan.technical;
    if (dv === 'Commercial' || dv === 'Comercial') defaultValue = lan.trade;
    if (dv === 'Support' || dv === 'Soporte') defaultValue = lan.support;
    if (dv === 'Other' || dv === 'Otro' || dv === 'Outro') defaultValue = lan.other;
    this.state = {
      value: defaultValue,
    };
  }
  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ value });
    this.props.onChange(value, 'jobPosition');
  };
  render() {
    const { lan, disabled } = this.props;
    return (
      <FormControl fullWidth size="small">
        <InputLabel>{lan.jobPosition}</InputLabel>
        <Select
          value={this.state.value}
          onChange={this.handleChange}
          label={lan.jobPosition}
          disabled={disabled}
        >
          <MenuItem value="0" disabled>{lan.jobPosition}</MenuItem>
          <MenuItem value={lan.administrative}>{lan.administrative}</MenuItem>
          <MenuItem value={lan.executive}>{lan.executive}</MenuItem>
          <MenuItem value={lan.technical}>{lan.technical}</MenuItem>
          <MenuItem value={lan.trade}>{lan.trade}</MenuItem>
          <MenuItem value={lan.support}>{lan.support}</MenuItem>
          <MenuItem value={lan.other}>{lan.other}</MenuItem>
        </Select>
      </FormControl>
    );
  }
}
export default SelectJobPosition;
//Original code:
/*import React, { Component } from 'react';

class SelectJobPosition extends Component {
	constructor(props) {
		super(props);

		let defaultValue = '0';
		if (this.props.defaultValue === 'Administrative' || this.props.defaultValue === 'Administrativo') {
			defaultValue = this.props.lan.administrative;
		}
		if (
			this.props.defaultValue === 'Executive' ||
			this.props.defaultValue === 'Ejecutivo' ||
			this.props.defaultValue === 'Executivo'
		) {
			defaultValue = this.props.lan.executive;
		}
		if (this.props.defaultValue === 'Technical' || this.props.defaultValue === 'Técnico') {
			defaultValue = this.props.lan.technical;
		}
		if (this.props.defaultValue === 'Commercial' || this.props.defaultValue === 'Comercial') {
			defaultValue = this.props.lan.trade;
		}
		if (this.props.defaultValue === 'Support' || this.props.defaultValue === 'Soporte') {
			defaultValue = this.props.lan.support;
		}
		if (
			this.props.defaultValue === 'Other' ||
			this.props.defaultValue === 'Otro' ||
			this.props.defaultValue === 'Outro'
		) {
			defaultValue = this.props.lan.other;
		}

		this.state = {
			defaultValue,
		};
	}
	render() {
		return (
			<>
				<select
					key='select-country'
					defaultValue={this.state.defaultValue}
					className='custom-select'
					id='taskType-red-input'
					onChange={(e) => this.props.onChange(e.target.value, 'jobPosition')}
					disabled={this.props.disabled}
				>
					<option disabled value='0'>
						{' '}
						{this.props.lan.jobPosition}
					</option>
					<option value={this.props.lan.administrative}>{this.props.lan.administrative}</option>
					<option value={this.props.lan.executive}>{this.props.lan.executive}</option>
					<option value={this.props.lan.technical}>{this.props.lan.technical}</option>
					<option value={this.props.lan.trade}>{this.props.lan.trade} </option>
					<option value={this.props.lan.support}>{this.props.lan.support}</option>
					<option value={this.props.lan.other}>{this.props.lan.other} </option>
				</select>
			</>
		);
	}
}
export default SelectJobPosition;
*/
